export default function alterNav(el: HTMLElement) {
  const mainMenu = el.querySelector('.main-nav-container');
  const mobileTrigger = el.querySelector('#navTrigger');

  if (mobileTrigger && mainMenu) {
    mobileTrigger.addEventListener('click', () => {
      mainMenu.classList.toggle('open');
    });
  }

  const subMenuButtons = el.querySelectorAll('a i');

  subMenuButtons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      e.preventDefault();

      const parent = button?.parentElement?.parentElement;

      if (!parent) {
        return;
      }

      const subMenu = parent.querySelector('.secondary-nav-container');

      if (subMenu) {
        subMenu.classList.toggle('open');
      }

      parent.classList.toggle('flip-icon');
    });
  });
}